import "./style.less";

export default function TermsModalController($scope, $element, terms, close) {
    $scope.terms = terms;

    $scope.modalClose = () => {
        $element.modal("hide");

        close(500); // close, but give 500ms for bootstrap to animate
    };
}
